"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SPEED = 1.5;

var Scrolling = /*#__PURE__*/function (_React$Component) {
  _inherits(Scrolling, _React$Component);

  var _super = _createSuper(Scrolling);

  function Scrolling(props) {
    var _this;

    _classCallCheck(this, Scrolling);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "transform", function (x) {
      var list = _this.scrollingListRef.current;

      if (list) {
        list.style.transform = "translateX(".concat(x, ")");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setCursor", function (isGrabbing) {
      var sliderRef = _this.scrollingListRef.current;

      if (sliderRef) {
        sliderRef.style.cursor = isGrabbing ? 'grabbing' : 'grab';
        sliderRef.style.userSelect = isGrabbing ? 'none' : 'auto';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentTranslateX", function () {
      var list = _this.scrollingListRef.current;

      if (list) {
        return parseInt((list.style.transform || '0').replace('translateX(', ''));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getTrackWidth", function () {
      var list = _this.scrollingListRef.current;
      return list ? list.clientWidth : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "transformOnResize", function () {
      var currentTransformX = _this.getCurrentTranslateX();

      var transformX = currentTransformX < 0 ? _this.getTransformX(currentTransformX) : 0;

      _this.transform(transformX);
    });

    _defineProperty(_assertThisInitialized(_this), "getTransformX", function (currentX) {
      var list = _this.scrollingListRef.current;

      var trackWidth = _this.getTrackWidth();

      var lastChildOffset = list.lastChild.offsetLeft + list.lastChild.offsetWidth;
      var maxOffset = lastChildOffset - trackWidth;
      var transformX = trackWidth < lastChildOffset && maxOffset > 0 ? Math.max(currentX, -maxOffset) : 0;
      return transformX + 'px';
    });

    _defineProperty(_assertThisInitialized(_this), "move", function (event, startX, startTransformX) {
      event.preventDefault();
      var xCoord = event.type === 'touchmove' ? event.touches[0].clientX : event.pageX;
      var walk = xCoord - startX;

      _this.setCursor(true);

      var transformX = _this.getTransformX(Math.min(0, startTransformX + walk * SPEED));

      _this.transform(transformX);
    });

    _defineProperty(_assertThisInitialized(_this), "startDrag", function (event) {
      var startTransformX = _this.getCurrentTranslateX();

      var startX = event.type === 'touchstart' ? event.touches[0].clientX : event.pageX;
      var ref = _this.scrollingTrackRef.current;

      ref.onmousemove = function (e) {
        return _this.move(e, startX, startTransformX);
      };

      ref.ontouchmove = function (e) {
        return _this.move(e, startX, startTransformX);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "endDrag", function () {
      _this.setCursor(false);

      var ref = _this.scrollingTrackRef.current;

      if (typeof ref.onmousemove === 'function') {
        ref.onmousemove = null;
        ref.ontouchmove = null;
      }
    });

    _this.scrollingTrackRef = /*#__PURE__*/_react["default"].createRef();
    _this.scrollingListRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(Scrolling, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window) {
        window.addEventListener('resize', this.transformOnResize);
      }

      var translate = this.props.translate;

      if (translate) {
        this.transform(translate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener('resize', this.transformOnResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          children = _this$props.children,
          translate = _this$props.translate;

      if (children !== prevProps.children) {
        this.transformOnResize();
      }

      if (translate !== prevProps.translate) {
        this.transform(translate);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["children"]);

      var dragNDropEvents = {
        onMouseDown: this.startDrag,
        onTouchStart: this.startDrag,
        onMouseUp: this.endDrag,
        onTouchEnd: this.endDrag,
        onMouseLeave: this.endDrag,
        onTouchCancel: this.endDrag
      };
      return /*#__PURE__*/_react["default"].createElement(_styled.Track, _extends({
        ref: this.scrollingTrackRef
      }, dragNDropEvents, {
        onDragStart: function onDragStart(e) {
          return e.preventDefault();
        }
      }, rest), /*#__PURE__*/_react["default"].createElement(_styled.List, {
        ref: this.scrollingListRef
      }, children));
    }
  }]);

  return Scrolling;
}(_react["default"].Component);

exports["default"] = Scrolling;